import { render, staticRenderFns } from "./RecycledDraftsTable.vue?vue&type=template&id=67748d33&scoped=true"
import script from "./RecycledDraftsTable.vue?vue&type=script&lang=js"
export * from "./RecycledDraftsTable.vue?vue&type=script&lang=js"
import style0 from "./RecycledDraftsTable.vue?vue&type=style&index=0&id=67748d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67748d33",
  null
  
)

export default component.exports